import { Pencil, Trash2 } from "lucide-react";
import type Plan from "../models/Plan";
import { useNavigate } from "react-router-dom";

function formatDuration(plan: Plan): string {
  const u = plan.timeUnits;
  if (u.years > 0) return `${u.years} año${u.years > 1 ? "s" : ""}`;
  if (u.months > 0) return `${u.months} mes${u.months > 1 ? "es" : ""}`;
  if (u.days > 0) return `${u.days} día${u.days > 1 ? "s" : ""}`;
  if (u.hours > 0) return `${u.hours} hora${u.hours > 1 ? "s" : ""}`;
  if (u.minutes > 0) return `${u.minutes} minuto${u.minutes > 1 ? "s" : ""}`;
  return "—";
}

interface PlanRowProps {
  plan: Plan;
  isLast: boolean;
  onDelete: (id: string) => void;
}

export function PlanRow({ plan, isLast, onDelete }: PlanRowProps) {
  const navigate = useNavigate();
  return (
    <div
      className={`grid grid-cols-5 gap-4 px-6 py-5 items-center transition-colors hover:bg-black/2 ${!isLast ? "border-b border-black/5" : ""
        }`}
    >
      <span className="font-semibold text-foreground">{plan.title}</span>
      <span className="text-foreground/50 text-sm truncate">
        {plan.description || "—"}
      </span>
      <span className="text-foreground/70 font-medium">
        {plan.price.toFixed(2)}{" "}
        <span className="text-xs text-foreground/40">US$</span>
      </span>
      <span className="text-foreground/70 font-medium text-sm">
        {formatDuration(plan)}
      </span>
      <div className="flex items-center gap-2 ml-auto">
        <button
          onClick={() => navigate(plan.id)}
          className="p-2 rounded-xl border border-black/5 bg-white/60 hover:bg-white hover:shadow-sm transition-all text-foreground/50 hover:text-accent"
        >
          <Pencil className="size-4" />
        </button>
        <button
          onClick={() => onDelete(plan.id)}
          className="p-2 rounded-xl border border-black/5 bg-white/60 hover:bg-red-50/80 hover:border-red-200/50 transition-all text-foreground/50 hover:text-red-500"
        >
          <Trash2 className="size-4" />
        </button>
      </div>
    </div>
  );
}
